import { useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useApiContext } from 'context/ApiContext';
import { useShowError } from 'hooks/useShowError';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigContext';

export function useDeleteConfiguracao() {
    const { activeGrupo, activeSubgrupo } = useDreConfigContext();
    const { showError } = useShowError();
    const { api } = useApiContext();
    const queryClient = useQueryClient();

    /**
     * Exclui a configuracao e atualiza a lista de configuracoes.
     */
    const handleDelete = (idConfiguracao: number) => {
        api.delete(`/dre/dremercadologicaconfiguracao/${idConfiguracao}/tipogrupoexibicao/${activeGrupo?.idDreMercadologicaTipoGrupoExibicao}`)
            .then(() => {
                queryClient.invalidateQueries([
                    'queryConfiguracoes',
                    activeGrupo?.idDreMercadologicaTipoGrupoExibicao,
                    activeSubgrupo?.idDreMercadologicaGrupoExibicao,
                ]);

                enqueueSnackbar('Configuração removida com sucesso', { variant: 'success' });
            })
            .catch((error) => showError(error, 'Falha ao remover a configuração. Tente novamente'));
    };

    return { handleDelete };
}
